// extracted by mini-css-extract-plugin
module.exports = {"container":"CartDropdown_container__kGM6m","cartItems":"CartDropdown_cartItems__t2NrR","loading":"CartDropdown_loading__9Jj_L"};